import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import LoadingUI from '../../../../comman/LoadingUI'
import Style from '../style/categoriesReward.module.scss'
import Skeleton from '@mui/material/Skeleton';
import AuthAxios from '../../../../config/authAxios';

const CategoriesReward = ({setCategoryId}) => {
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false);
  const [CategoryData, setCategoryData] = useState([]);
  const [is_ads_enabled, setIs_ads_enabled] = useState(false);
  const fetchCategory = async (params) => {
    try {
      setLoading(true);
      const response = await AuthAxios.get("/users/api/all-categories");    
      setCategoryData(response?.data?.data);
      setLoading(false);
    } catch (error) {
      console.error(error)
    }
  }

  const handleClick=(item)=>{
    console.log("teimsjhfahj",item)
     navigate(`/subcategory-mission/${item?._id}`, { state: { catname: item.cat_name } });
  }

  useEffect(() => {
    fetchCategory();
  }, [])

  return (
    <>
      <div className={Style.theme__banner}>
        <p>Quiz Genre</p>
      </div>
      <div className={Style.categories_sec}>

        {loading ? <>
          <Skeleton
            variant="rectangular"
            width={350}
            height={118}
            style={{ borderRadius: '80% 80% 20% 20%' }}
          />
          <Skeleton
            variant="rectangular"
            width={350}
            height={118}
            style={{ borderRadius: '80% 80% 20% 20%' }}
          />
          <Skeleton
            variant="rectangular"
            width={350}
            height={118}
            style={{ borderRadius: '80% 80% 20% 20%' }}
          />
        </> : CategoryData?.length > 0 ? (CategoryData.map((item, index) => {
          return (
            <>
              <div key={item?._id} className={Style.categorie} onClick={()=>handleClick(item)}>
                <div className={Style.categorie_img_container}>
                  <div className={Style.categorie_img}>
                  <img src={item.image} alt="img--" />
                  </div>
                </div>
                <div className={Style.categoriep_name}>
                  <p className={Style.categorie_p} style={{ fontSize: "0.9rem" }}>
                    {item.cat_name}
                  </p>
                </div>
                {/* <div>
                  <button className={Style.category_button} onClick={() => { navigate('/sub-category', { state: { cat_id: item._id, catname: item.cat_name } }) }}>
                    View
                  </button>
                </div> */}
              </div>
              {index % 2 !== 0 && is_ads_enabled && <div className={Style.categorie}>
                ads
              </div>}

            </>)
        })) : (<>
          <Skeleton
            variant="rectangular"
            width={350}
            height={118}
            style={{ borderRadius: '80% 80% 20% 20%' }}
          />
          <Skeleton
            variant="rectangular"
            width={350}
            height={118}
            style={{ borderRadius: '80% 80% 20% 20%' }}
          />
          <Skeleton
            variant="rectangular"
            width={350}
            height={118}
            style={{ borderRadius: '80% 80% 20% 20%' }}
          />
        </>)}
      </div>
    </>
  )
}

export default CategoriesReward;